import moment from 'moment';

export const CONSTANTS = {
    bookDemo: 'https://go.minute7.com/demo',
};

export const NO_EMPLOYEE_AND_VENDOR_ASSOCIATION_STRING = `Your Minute7 user account does not currently
    have access to enter time or expenses. Please contact your account manager and ask them
    to go to the "Account" tab in Minute7 and edit your user account settings by
    choosing a QuickBooks Vendor and/or Employee to associate with your user account.`;

export const NO_EMPLOYEE_ASSOCIATION_STRING = `Your Minute7 user account does not currently
    have access to enter time. Please contact your account manager and ask them
    to go to the "Account" tab in Minute7 and edit your user account settings by
    choosing a QuickBooks Employee or Vendor to associate with your user account.`;

export const NO_VENDOR_ASSOCIATION_STRING = `Your Minute7 user account does not currently
    have access to enter expenses. Please contact your account manager and ask them
    to go to the 'Account' tab in Minute7 and edit your user account settings by
    choosing a QuickBooks Vendor to associate with your user account.`;

export const MIDNIGHT = moment()
    .hour(0)
    .minute(0)
    .format('HH:mm:ss');

// Preferred Distance Unists
export const MILES = 'miles';
export const KILOMETERS = 'kilometers';

// Reimbursement Rate types
export const COMPANY = 'company';
export const INDIVIDUAL = 'individual';

export const SHOW_NOTE_FIELD = false;

// US States + DC + Territories
export const US_STATES = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'District of Columbia', value: 'DC' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Virgin Islands', value: 'VI' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
];

// Combined list: US States + Other (for non-US companies)
export const ALL_STATES = [...US_STATES, { label: 'Other (Non-US)', value: 'OTHER' }];
